import { CaCompositionTable } from "../dashboard/CaCompositionTable";
import { SummaryCards } from "../dashboard/SummaryCards";
import { CaTrendSection } from "./global/components/CaTrendSection";
import { useGlobalAnalytics } from "./global/hooks/useGlobalAnalytics";
import { ServicesLoadingState } from "./services/components/ServicesLoadingState";

interface GlobalTabProps {
  from: string;
  to: string;
  basis: "accrual" | "cash";
}

export function GlobalTab({ from, to, basis }: GlobalTabProps) {
  const { summary, composition, trend, loading } = useGlobalAnalytics({ from, to, basis });

  if (loading || !summary || !composition) return <ServicesLoadingState />;

  return (
    <div>
      <SummaryCards summary={summary} />
      <CaCompositionTable composition={composition} />
      <CaTrendSection trend={trend} />
    </div>
  );
}
